<template>
  <div class="login-container">
    <!--    <span>QQ第三方登录 - 回调页面</span>-->
    <p>正在加载中...</p>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "qqLogin",
  data() {
    return {
      redirect: undefined,
    };
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created() {
    this.qqLogin();
  },
  methods: {
    // QQ第三方登录
    qqLogin() {
      console.log("QQ回调页面:" + this.$route.query)
      var that = this; // 先将vue这个对象保存在_self对象中
      //检查是否登录
      if (QC.Login.check()) {
        //该处的openId，accessToken就是后台需要的参数了，后台通过这些参数拿取临时登录凭证，然后就是自己的逻辑了
        QC.Login.getMe(function(openId, accessToken) {
          // 跳转路由 携带数据
          that.$router.push({
            path: `/liveList`,
            query: {
              //路由传参时push和query搭配使用 ，作用：传递参数
              openId: openId,
              accessToken: accessToken,
            },
          });
        });
        console.log("已登录!");
      } else {
        console.log("未登录!");
      }
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="less"></style>
